import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import Input from "../../../../Components/Input/Input";
// import { FiSearch } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import AutoCompleteSearch from "../../../../Components/AutoCompleteSearch/AutoCompleteSearch";
import { getAllFilteredEmployees } from "../../../../Redux/Actions/HR";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../../Components/Header/Header";
import MetaData from "../../../../Components/MetaData";
import AddPurchaseRequisitionModal from "./AddPurchaseRequisitionModal";
import {
  getAllPurchaseRequisitions,
  deletePurchaseRequisition,
} from "../../../../Redux/Actions/PurchaseRequisitions";
import MuiDataTable from "../../../../Components/MUIDataTable/MUIDataTable";
import Loader from "../../../../Utils/Loader";
import { Avatar, Typography } from "@mui/material";
import { FaEye } from "react-icons/fa";
import { BsTrashFill } from "react-icons/bs";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { errorNotify, successNotify } from "../../../../Utils/toast";
import { BiSearch, BiReset } from "react-icons/bi";
import { useStyle } from "../Attendance/attendance-styles";
import DeleteConfirmModal from "../../../../Components/DeleteConfirmModal/DeleteConfirmModal";

const PurchaseRequisitions = () => {
  const [id, setId] = useState();
  const [addModal, setAddModal] = useState(false);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [ceoStatus, setCeoStatus] = useState("");
  const [accountsStatus, setAccountsStatus] = useState("");
  const [priority, setPriority] = useState("");
  const [createdMonth, setCreatedMonth] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [requisitionIdToDelete, setRequisitionIdToDelete] = useState("");
  const classes = useStyle();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchName, setSearchName] = useState("");
  const [pageSearch, setPageSearch] = useState(false);
  const [isSearched, setIsSearch] = useState(false);
  const { employees: filtered } = useSelector(
    (state) => state.filteredEmployees
  );
  const {
    loading,
    requisitions = [],
    error,
    requisitionCount = 0,
  } = useSelector((state) => state.getPurchaseRequisitions);

  const { success } = useSelector((state) => state.createPurchaseRequisition);
  const {
    deleted,
    loading: deletedLoading,
    error: deleteError,
  } = useSelector((state) => state.deletePurchaseRequisition);

  const { user } = useSelector((state) => state.currentUser);

  // Check if user has access to this module
  const hasAccess =
    (user?.user?.department?._id === "68875ce1f9c0eda4dcce9c74" ||
      user?.user?.department?._id === "6392e6b4758449db0ae81600" ||
      user?.user?.department?._id === "63d8c6158c662fd4d455ce85") &&
    (user?.user?.role === "HR" ||
      user?.user?.role === "admin" ||
      user?.user?.role === "employee");

  useEffect(() => {
    const handleBeforeUnload = () => {
      // Remove particular data from localStorage
      window.sessionStorage.removeItem("saveUser");

      setSearchName("");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (!hasAccess) {
      navigate("/HR/dashboard");
      return;
    }

    const getUser = JSON.parse(window.sessionStorage.getItem("saveUser"));
    if (getUser) {
      setSearchName(getUser.full_name);
      setIsSearch(true);
      dispatch(getAllFilteredEmployees());
      dispatch(getAllPurchaseRequisitions(page, size, getUser?._id));
    } else {
      setIsSearch(false);
      dispatch(getAllFilteredEmployees());
      dispatch(getAllPurchaseRequisitions(page, size));
    }
  }, [hasAccess, navigate]);

  useEffect(() => {
    if (!hasAccess) return;

    dispatch(
      getAllPurchaseRequisitions(
        page,
        size,
        "",
        ceoStatus,
        accountsStatus,
        priority,
        createdMonth
      )
    );
  }, [
    page,
    size,
    ceoStatus,
    accountsStatus,
    priority,
    createdMonth,
    hasAccess,
  ]);

  useEffect(() => {
    if (success) {
      setAddModal(false);
      dispatch(getAllPurchaseRequisitions(page, size));
    }
    if (deleted?.success) {
      successNotify(deleted?.message);
      setShowDeleteModal(false);
      dispatch({ type: "DELETE_PURCHASE_REQUISITION_RESET" });
      dispatch(getAllPurchaseRequisitions(page, size));
    }
    if (deleteError) {
      errorNotify(deleteError);
      dispatch({ type: "CLEAR_ERRORS" });
    }
  }, [success, deleted?.success, deleteError]);

  const openDeleteConfirm = (id) => {
    setRequisitionIdToDelete(id);
    setShowDeleteModal(true);
  };

  const requisitionColumns = [
    {
      name: "_id",
      options: {
        display: false,
      },
    },
    {
      name: "request_by",
      label: "Request By",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Avatar src={value?.profile_picture?.[0]?.fileName} />
              <Typography
                onClick={() => navigate(`/HR/employee/${value?._id}`)}
                style={{
                  cursor: "pointer",
                }}
                sx={{ pl: 1 }}
                className="fs-12 link__color"
              >
                {value ? value.full_name : "-"}
              </Typography>
            </div>
          );
        },
      },
    },
    {
      name: "item_name",
      label: "Item Name",
      options: {
        customBodyRender: (value) => (
          <Typography sx={{ pl: 1, margin: "0 auto" }} className="fs-12">
            {value ? value : "-"}
          </Typography>
        ),
      },
    },
    {
      name: "required_by_date",
      label: "Required By",
      options: {
        customBodyRender: (value) => (
          <Typography sx={{ pl: 1 }} className="fs-12">
            {value ? moment(value).format("DD-MM-YYYY") : "-"}
          </Typography>
        ),
      },
    },
    {
      name: "ceo_status",
      label: "CEO Status",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
              className={`${
                value === "approved"
                  ? classes.present
                  : value === "rejected"
                  ? classes.absent
                  : value === "pending"
                  ? classes.halfDay
                  : classes.late
              }`}
              sx={{ fontSize: "10px", pl: 1, fontWeight: "600" }}
            >
              {value ? value : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "accounts_status",
      label: "Accounts Status",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
              className={`${
                value === "approved"
                  ? classes.present
                  : value === "rejected"
                  ? classes.absent
                  : value === "pending"
                  ? classes.halfDay
                  : classes.late
              }`}
              sx={{ fontSize: "10px", pl: 1, fontWeight: "600" }}
            >
              {value ? value : "-"}
            </Typography>
          );
        },
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div className="leaves_management_btn_container">
              <button
                className="edit_btn"
                onClick={() =>
                  user?.user?.role === "employee"
                    ? navigate(
                        `/employee/purchase-requisition/${tableMeta.rowData[0]}`,
                        {
                          state: {
                            update: true,
                          },
                        }
                      )
                    : navigate(
                        `/HR/purchase-requisition/${tableMeta.rowData[0]}`,
                        {
                          state: {
                            update: true,
                          },
                        }
                      )
                }
              >
                <FaEye />
              </button>
              <button
                className="delete_btn"
                onClick={() => openDeleteConfirm(tableMeta.rowData[0])}
              >
                <BsTrashFill />
              </button>
            </div>
          );
        },
      },
    },
  ];

  // Apply button removed; refetch happens automatically via useEffect on filter change

  const clearFilters = () => {
    setCeoStatus("");
    setAccountsStatus("");
    setPriority("");
    setCreatedMonth("");
    setPage(0);
    dispatch(getAllPurchaseRequisitions(0, size));
  };

  // If user doesn't have access, show access denied message
  if (!hasAccess) {
    return (
      <div className="page_responsive">
        <Header title="Access Denied" />
        <Container fluid>
          <Row className="justify-content-center">
            <Col md={8}>
              <div className="text-center mt-5">
                <h3 style={{ color: "#dc3545" }}>Access Denied</h3>
                <p>
                  You don't have permission to access the Purchase Requisitions
                  module.
                </p>
                <p>
                  <strong>Required Department:</strong> Accounts or Admin
                </p>
                <p>
                  <strong>Required Role:</strong> HR, Admin, or Employee
                </p>
                <p>
                  <strong>Your Department:</strong>{" "}
                  {user?.user?.department_name || "Unknown"}
                </p>
                <p>
                  <strong>Your Role:</strong> {user?.user?.role || "Unknown"}
                </p>
                <p>
                  Please contact your administrator if you believe this is an
                  error.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <>
      <DeleteConfirmModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={() => dispatch(deletePurchaseRequisition(requisitionIdToDelete))}
        loading={deletedLoading}
        message="Are u sure you want to delete this purchase requisition?"
      />
      <div className="page_responsive">
        <Header title="Purchase Requisitions" />
        <MetaData title={`Purchase Requisitions -- HRM`} />
        <Container fluid>
          <Row className="m-0">
            <Col md={12}>
              <div className="employees_main_selection">
                <Form>
                  <Row className="align-items-start">
                    <Col md={12}>
                      <Row className="align-items-end">
                        <Col md={2}>
                          <Input>
                            <Form.Label>CEO Status</Form.Label>
                            <Form.Select
                              value={ceoStatus}
                              onChange={(e) => setCeoStatus(e.target.value)}
                            >
                              <option value="">All</option>
                              <option value="pending">Pending</option>
                              <option value="approved">Approved</option>
                              <option value="rejected">Rejected</option>
                            </Form.Select>
                          </Input>
                        </Col>
                        <Col md={2}>
                          <Input>
                            <Form.Label>Accounts Status</Form.Label>
                            <Form.Select
                              value={accountsStatus}
                              onChange={(e) =>
                                setAccountsStatus(e.target.value)
                              }
                            >
                              <option value="">All</option>
                              <option value="pending">Pending</option>
                              <option value="approved">Approved</option>
                              <option value="rejected">Rejected</option>
                            </Form.Select>
                          </Input>
                        </Col>
                        <Col md={2}>
                          <Input>
                            <Form.Label>Priority</Form.Label>
                            <Form.Select
                              value={priority}
                              onChange={(e) => setPriority(e.target.value)}
                            >
                              <option value="">All</option>
                              <option value="low">Low</option>
                              <option value="medium">Medium</option>
                              <option value="high">High</option>
                              <option value="urgent">Urgent</option>
                            </Form.Select>
                          </Input>
                        </Col>
                        <Col md={3}>
                          <Input>
                            <Form.Label>Created Month</Form.Label>
                            <Form.Control
                              type="month"
                              value={createdMonth}
                              onChange={(e) => setCreatedMonth(e.target.value)}
                            />
                          </Input>
                        </Col>
                        <Col
                          md={3}
                          style={{
                            display: "flex",
                            gap: "2px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "12px",
                              width: "100%",
                            }}
                          >
                            <button
                              type="button"
                              onClick={clearFilters}
                              style={{
                                padding: "10px 20px",
                                background:
                                  "linear-gradient(to bottom, #0097d9, #00b1ff)",
                                boxShadow:
                                  "0 15px 20px 0 rgb(13 110 253 / 30%)",
                                border: "none",
                                width: "100%",
                                fontSize: "12px",
                                fontWeight: 500,
                                borderRadius: "10px",
                                color: "white",
                              }}
                            >
                              <BiReset /> Reset
                            </button>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "12px",
                              width: "100%",
                              marginBottom: "4px",
                            }}
                          >
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                setAddModal(true);
                              }}
                              style={{
                                padding: "10px 20px",
                                background: "#ee1c25",
                                boxShadow:
                                  "0 15px 20px 0 rgb(13 110 253 / 30%)",
                                border: "none",
                                width: "100%",
                                fontSize: "12px",
                                fontWeight: 500,
                                borderRadius: "10px",
                                color: "white",
                              }}
                            >
                              <AiOutlinePlus /> Create
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
            <Col md={12}>
              {loading ? (
                <Loader />
              ) : (
                <div className="tickets_management_table">
                  <MuiDataTable
                    title={"ALL PURCHASE REQUISITIONS"}
                    columns={requisitionColumns}
                    data={requisitions || []}
                    page={page}
                    setPage={setPage}
                    rowsPerPage={size}
                    setRowsPerPage={setSize}
                    count={requisitionCount || 0}
                    text={searchText}
                    setText={setSearchText}
                    tableId="hr_purchase_requisitions_table"
                  />
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
      <AddPurchaseRequisitionModal
        modalOpen={addModal}
        setModalOpen={setAddModal}
      />
    </>
  );
};

export default PurchaseRequisitions;
